import * as yup from 'yup';

export const createModerationSchema = (t: (key: string) => string) =>
  yup.object({
    whatsApp: yup.string(),
    volume: yup.string().required(t('moderation.validationErrors.volumeRequiredNew')),
    tgTag: yup
      .string()
      .required(t('moderation.validationErrors.telegramRequired'))
      .min(3, t('moderation.validationErrors.telegramMin')),
    language: yup.string(),
    sourceInfoAboutUs: yup.string(),
    experienceDescription: yup.string().when('hasOnlyFansExperience', {
      is: true,
      then: (schema) =>
        schema
          .required(t('moderation.validationErrors.experienceRequiredNew'))
          .max(
            500,
            t('moderation.validationErrors.experienceMax') ||
              'Experience description must be at most 500 characters'
          ),
      otherwise: (schema) => schema,
    }),
    sources: yup
      .array()
      .of(yup.string())
      .min(1, t('moderation.validationErrors.sourcesRequiredNew'))
      .required(t('moderation.validationErrors.sourcesRequiredNew')),
    hasOnlyFansExperience: yup.boolean(),
  });

export type ModerationFormData = yup.InferType<ReturnType<typeof createModerationSchema>>;
